import { call, put, take, takeEvery } from 'typed-redux-saga';

import { HaltReason } from '../../../../../../shared/features/room-agent/constants';
import { debugHalt } from '../../../../../../shared/features/room-agent/dtmf/debug-menu/actions';
import { SignalingAPI } from '../../../../../../shared/features/room-agent/SignalingAPI';
import { disconnectConferenceAction, disconnectedFromConferenceDoneAction } from '../../../conference/slice';

export function* debugSaga({ signaling }: { signaling: SignalingAPI }) {
    yield* takeEvery(debugHalt, function* () {
        try {
            yield* put(disconnectConferenceAction());
            yield* take(disconnectedFromConferenceDoneAction);
        } finally {
            yield* call([signaling, signaling.halt], {
                reason: HaltReason.NO_INTERNET_CONNECTION,
                description: `Debug halt`,
            });
        }
    });
}
